import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

export enum ContactServiceAction {
  CREATE_DESK_TICKET = "CREATE_DESK_TICKET",
  UPLOAD_IMAGE = "UPLOAD_IMAGE",
  CLEAN_UP = "CLEAN_UP_CONTACT_SERVICE",
  UPDATE_STATE = "UPDATE_STATE_CONTACT_SERVICE",
}

interface PurchaseDetails {
  invoice: string;
  date_of_purchase: string; // Consider using Date if this is handled as a date object
  store_name: string;
  store_phone: string;
  store_address: string;
  store_city: string;
  store_state: string;
  were_any_items_exchanged: string;
  store_zip: string;
}

interface CustomerDetails {
  name: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zip_code: string;
}

export interface ClaimItemDamage {
  damage_category: string;
  specific_damage: string;
  damage_area: string;
  when_did_you_notice_the_damage: string;
  how_did_it_happen: string;
  did_you_take_any_steps_to_remedy: string;
  note: string;
}

interface Documents {
  invoice: [string?];
}

export interface ContactServiceState {
  documents: Documents;
  purchaseDetails: PurchaseDetails;
  customerDetails: CustomerDetails;
  claimItemDamage: ClaimItemDamage[];
}

export type ContactServiceTypes = ReturnType<InferValueTypes<typeof actions>>;

export const ContactServiceScope = "contact-service";
